import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { UserContext } from '../../../components/auth/auth-context';
import PasswordRecoveryForm from '../../../components/auth/PasswordRecoveryForm';
export default function UserPageChangepassword() {
  const { providerUser } = useContext(UserContext);
  return <Box sx={{ p: 2, maxWidth: 480 }}><PasswordRecoveryForm initialEmail={providerUser?.email || ''} /></Box>;
}
